import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import AuthLayout from "../components/layout/AuthLayout";
import Button from "../components/common/Button";
import { resendAgentVerification, verifyAgentEmail } from "../lib/agentAuth";
import { showApiError, showSuccessAction } from "../lib/alerts";
import { BRAND } from "../lib/brand";

export default function VerifyEmailPage() {
  const [searchParams] = useSearchParams();
  const [email, setEmail] = useState(searchParams.get("email") || "");
  const [token, setToken] = useState(searchParams.get("token") || "");
  const [loading, setLoading] = useState(false);
  const [resending, setResending] = useState(false);

  useEffect(() => {
    const queryEmail = searchParams.get("email") || "";
    const queryToken = searchParams.get("token") || "";
    if (queryEmail) {
      setEmail(queryEmail);
    }
    if (queryToken) {
      setToken(queryToken);
    }
  }, [searchParams]);

  async function handleVerify(event) {
    event.preventDefault();
    setLoading(true);

    try {
      await verifyAgentEmail({
        email: email.trim(),
        token: token.trim(),
      });
      showSuccessAction("VERIFY_EMAIL");
    } catch (verifyError) {
      showApiError(verifyError, "VERIFY_EMAIL");
    } finally {
      setLoading(false);
    }
  }

  async function handleResend() {
    setResending(true);

    try {
      await resendAgentVerification(email.trim());
      showSuccessAction("RESEND_VERIFICATION");
    } catch (resendError) {
      showApiError(resendError, "RESEND_VERIFICATION");
    } finally {
      setResending(false);
    }
  }

  return (
    <AuthLayout>
      <div className="max-w-464-px mx-auto w-100 auth-form-card">
        <Link to="/login" className="mb-40 max-w-290-px d-inline-block">
          <img src={BRAND.logo} alt={BRAND.name} className="auth-brand-logo" />
        </Link>
        <h4 className="mb-12">Verify email</h4>
        <p className="mb-24 text-secondary-light text-lg">
          Confirm your travel-partner email address to finish registration.
        </p>
        <form onSubmit={handleVerify}>
          <div className="mb-16">
            <label className="form-label fw-semibold text-primary-light text-sm mb-8" htmlFor="verify-email">
              Email
            </label>
            <input
              type="email"
              className="form-control h-56-px bg-neutral-50 radius-12"
              id="verify-email"
              placeholder="name@agency.com"
              value={email}
              onChange={(event) => setEmail(event.target.value)}
              required
            />
          </div>
          <div className="mb-16">
            <label className="form-label fw-semibold text-primary-light text-sm mb-8" htmlFor="verify-token">
              Verification token
            </label>
            <input
              type="text"
              className="form-control h-56-px bg-neutral-50 radius-12"
              id="verify-token"
              placeholder="Paste the token from your email"
              value={token}
              onChange={(event) => setToken(event.target.value)}
              required
            />
          </div>
          <Button type="submit" className="btn btn-primary text-sm btn-sm px-12 py-16 w-100 radius-12" disabled={loading}>
            {loading ? "Verifying..." : "Verify email"}
          </Button>
          <Button
            type="button"
            className="btn btn-outline-secondary border-neutral-100 text-sm btn-sm px-12 py-16 w-100 radius-12 mt-12"
            onClick={handleResend}
            disabled={resending || !email.trim()}
          >
            {resending ? "Resending..." : "Resend verification email"}
          </Button>
          <div className="mt-24 text-center text-sm">
            <p className="mb-0">
              Back to <Link to="/login" className="text-primary-600 fw-semibold">sign in</Link>
            </p>
          </div>
        </form>
      </div>
    </AuthLayout>
  );
}
